module.exports = __webpack_public_path__ + "static/media/tour2.72024c90.svg";